// 给客户端(如安卓、ios)调用挂在 window 上的 js 方法加后缀，防止与页面自身全局变量冲突
class WindowLib {
  constructor() {
    this.nameSuffix = 'NativeFn'
  }

  /**
   * 把回调挂到 window.<name>NativeFn
   * @param {string} name 原生约定的方法名（不带后缀）
   * @param {Function} value 回调函数
   * @param {Object} options cover: true 同名覆盖（默认）；false 已存在则不覆盖
   */
  addAttr(name, value, options = { cover: true }) {
    const key = name + this.nameSuffix
    if (!options.cover && window[key] !== undefined) {
      return
    }
    window[key] = value
  }

  /**
   * 从 window 上移除回调（页面卸载时调用）
   * @param {string} name 原生约定的方法名（不带后缀）
   */
  removeAttr(name) {
    const key = name + this.nameSuffix
    delete window[key]
  }
}

export default WindowLib
